import React from "react";
import { TextField } from "@mui/material";

type InputType = "number" | "date" | "time" | "text" | "textarea";

type UniversalInputProps = {
  label: string;
  type: InputType;
  value: string | number | null;
  onChange: (value: string | number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  rows?: number; // opcjonalnie liczba linii textarea
};

export const UniversalInput: React.FC<UniversalInputProps> = ({
                                                                label,
                                                                type,
                                                                value,
                                                                onChange,
                                                                min,
                                                                max,
                                                                step,
                                                                disabled,
                                                                rows = 4,
                                                              }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;

    if (type === "number") {
      const num = Number(val);
      if (
        !isNaN(num) &&
        Number.isInteger(num) &&
        (min === undefined || num >= min)
      ) {
        onChange(num);
      }
    } else {
      onChange(val);
    }
  };

  return (
    <TextField
      label={label}
      type={type === "textarea" ? "text" : type}
      value={value ?? ""}
      onChange={handleChange}
      disabled={disabled}
      fullWidth
      multiline={type === "textarea"}
      rows={type === "textarea" ? rows : undefined}
      inputProps={{
        min,
        max,
        step,
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};
